import React, {useEffect} from "react";
import {connect} from 'react-redux';
import {bindActionCreators} from "redux";

import userActions from '../../../store/user/actions';

type Props = {
    logOut: Function;
};
const View = ({logOut}: Props) => {
    useEffect(() => {
        logOut()
    }, [])
    return <div></div>
}
//@ts-expect-error
const dispatchProps = (dispatch) => ({
    logOut: bindActionCreators(userActions.logOut, dispatch),
})
export default  connect(null, dispatchProps)(View);